import { Card, Checkbox, Col, Form, Row, Select, message, Button } from "antd";
import React, { useEffect, useState } from "react";
import { collection, doc, getDocs, updateDoc } from "firebase/firestore";
import { glAccounts } from "../../../../data/accounting";
import { db } from "../../../../firebase";
import { RiCloseCircleLine, RiAddCircleFill } from "react-icons/ri";
import { v4 as uuidv4 } from "uuid";

import "./OwnerPacket.css";
import { useParams } from "react-router-dom";
import FormAction from "../../../../components/common/FormAction";

function OwnerPacket({ data, renderData, companyName }) {
  const [checked, setChecked] = useState(false);
  const [selectedGlAccounts, setSelectedGlAccounts] = useState(
    data?.includedReports
  );
  const [includedReports, setIncludedReports] = useState([
    { id: uuidv4(), includedReport: "" },
  ]);
  const { id } = useParams();

  const [form] = Form.useForm();
  useEffect(() => {
    if (companyName) {
      const fetchTenants = async () => {
        try {
          const tenantRef = collection(db, "companies", companyName, "owners");
          const snapshot = await getDocs(tenantRef);
          const fetchedData = snapshot.docs.map((doc) => ({
            id: doc.id,
            ...doc.data(),
          }));
          console.log("Fetched data....*****", fetchedData);
          const filteredTenant = fetchedData.find((item) => item.id === id);
          console.log("filtered reports", filteredTenant);
          setIncludedReports(
            filteredTenant?.ownerPackets?.includedReports?.length >= 1
              ? filteredTenant?.ownerPackets?.includedReports
              : [{ id: uuidv4(), includedReport: "" }]
          );
        } catch (err) {
          console.error(err);
          alert(err.message);
        }
      };
      fetchTenants();
    }
  }, [companyName, checked]);

  const handleChange = (value, name, id) => {
    const updatedReports = includedReports.map((item) => {
      if (item.id === id) {
        return { ...item, [name]: value };
      }
      return item;
    });
    setIncludedReports(updatedReports);
  };

  const addReport = () => {
    const newReport = {
      id: uuidv4(),
      includedReport: "",
    };
    setIncludedReports([...includedReports, newReport]);
  };

  const removeReport = (id) => {
    const updatedReports = includedReports.filter((item) => item.id !== id);
    setIncludedReports(updatedReports);
  };

  const onFinish = async (values) => {
    //console.log("Owner Packet success", values);
    values.includedReports = selectedGlAccounts || " ";

    form.setFieldsValue(values);
    const ownerRef = doc(db, "companies", companyName, "owners", id);

    const reports = includedReports.filter((item) => {
      return Object.keys(item).some((key) => key !== "id" && item[key] !== "");
    });

    const ownerPackets = {
      ownerPackets: {
        sendViaEmail: data.sendViaEmail,
        includePaidWorkOrders: data.includePaidWorkOrders,
        includePaidWorkOrderAttachments: data.includePaidWorkOrderAttachments,
        includePaidBillsAttachments: data.includePaidBillsAttachments,
        glAccountMap: data.glAccountMap,
        includedReports: reports,
      },
    };

    try {
      await updateDoc(ownerRef, ownerPackets);
      message.success("Owner Packet data Updated SuccessFully!");
      setChecked(false);
      renderData(true);
    } catch (err) {
      console.error(err);
      message.error(err.message);
    }
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
    message.error("Owner Packet data Update Failed!");
  };
  const onCancel = () => {
    setChecked(false);
  };
  const defaultValues = {
    sendViaEmail: data?.sendViaEmail ? data?.sendViaEmail : false,
    includePaidWorkOrders: data?.includePaidWorkOrders
      ? data?.includePaidWorkOrders
      : " ",
    includePaidWorkOrderAttachments: data?.includePaidWorkOrderAttachments
      ? data?.includePaidWorkOrderAttachments
      : false,
    includePaidBillsAttachments: data?.includePaidBillsAttachments
      ? data?.includePaidBillsAttachments
      : false,
    glAccountMap: data?.glAccountMap ? data?.glAccountMap : false,
    includedReports: data?.includedReports ? data?.includedReports : false,
  };

  // console.log("Owner Packet====>", data?.includedReports)
  return (
    <Row>
      <Col span={24}>
        <Card
          title="Owner Packet"
          extra={
            !checked ? (
              <span className="onclick-text" onClick={() => setChecked(true)}>
                Edit
              </span>
            ) : null
          }
        >
          {checked ? (
            <div className="owner-packet">
              <Form
                colon={false}
                labelCol={{ span: 8 }}
                wrapperCol={{ span: 11 }}
                labelWrap={{ span: 8 }}
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                initialValues={defaultValues}
              >
                <Col span={24}>
                  <Form.Item
                    label="Owner specific notes"
                    name="sendViaEmail"
                    valuePropName="checked"
                  >
                    <Checkbox></Checkbox>
                  </Form.Item>
                  <Form.Item
                    label="Include Paid Work Orders"
                    name="includePaidWorkOrders"
                    valuePropName="checked"
                  >
                    <Checkbox></Checkbox>
                  </Form.Item>
                  <Form.Item
                    label="Include Paid Work Orders Attachments"
                    name="includePaidWorkOrderAttachments"
                    valuePropName="checked"
                  >
                    <Checkbox></Checkbox>
                  </Form.Item>
                  <Form.Item
                    label="Include Paid Bills Attachments"
                    name="includePaidBillsAttachments"
                    valuePropName="checked"
                  >
                    <Checkbox></Checkbox>
                  </Form.Item>
                  <Form.Item label="GL Account Map" name="glAccountMap">
                    <Select
                      options={[{ value: "test 1" }, { value: "test 2" }]}
                    />
                  </Form.Item>
                  <Form.Item label="Included Reports" name="includedReports">
                    <Row gutter={[0, 8]}>
                      {includedReports.map((item, index) => {
                        return (
                          <Col span={24} key={index}>
                            <Row align="middle" gutter={[16, 0]}>
                              <Col span={24}>
                                <Select
                                  defaultValue={
                                    data?.includedReports &&
                                    data?.includedReports
                                  }
                                  style={{}}
                                  value={item.includedReport}
                                  onChange={(value) =>
                                    handleChange(
                                      value,
                                      "includedReport",
                                      item.id
                                    )
                                  }
                                  tokenSeparators={[","]}
                                  options={glAccounts}
                                />
                              </Col>
                              {includedReports.length > 1 ? (
                                <Col span={1}>
                                  <RiCloseCircleLine
                                    size={22}
                                    onClick={() => removeReport(item.id)}
                                    className="delete-btn"
                                  />
                                </Col>
                              ) : null}
                            </Row>
                          </Col>
                        );
                      })}
                      <Col span={24}>
                        <Button className="add-icon-btn" onClick={addReport}>
                          <RiAddCircleFill size={18} />
                          Add Another Report
                        </Button>
                      </Col>
                    </Row>
                  </Form.Item>
                </Col>

                <FormAction
                  className="contact-actions"
                  submit={"submit"}
                  cancel={onCancel}
                />
              </Form>
            </div>
          ) : (
            <Form
              colon={false}
              labelCol={{ span: 8 }}
              wrapperCol={{ span: 11 }}
              labelWrap={{ span: 8 }}
            >
              <Form.Item label="Send via Email">
                <p>{data?.sendViaEmail ? "Yes" : "No"}</p>
              </Form.Item>
              <Form.Item label="Include Paid Work Orders">
                <p>{data?.includePaidWorkOrders ? "Yes" : "No"}</p>
              </Form.Item>
              <Form.Item label="Include Paid Work Orders Attachments">
                <p>{data?.includePaidWorkOrderAttachments ? "Yes" : "No"}</p>
              </Form.Item>
              <Form.Item label="Include Paid Bills Attachments">
                <p>{data?.includePaidBillsAttachments ? "Yes" : "No"}</p>
              </Form.Item>
              <Form.Item label="GL Account Map">
                <p>{data?.glAccountMap ? "Yes" : "None"}</p>
              </Form.Item>
              <Form.Item label="Included Reports">
                {/* <p>
                  {Array.isArray(data?.includedReports)
                    && data?.includedReports.length ? data.includedReports.map((item, index) =>
                      console.log("Owner Packet data====>", item)
                        (
                          <span key={index}>{item} and {" "}</span>
                        ))
                    : "--"}
                </p> */}
                <p>{data?.includedReports ? data.includedReports : "--"}</p>
              </Form.Item>
            </Form>
          )}
        </Card>
      </Col>
    </Row>
  );
}

export default OwnerPacket;
